<app-timeline-item [title]="'Start Matching period ' + currentMatchingPeriod?.matchingPeriodName" [icon]="'add'" [level]="'end'" [inverted]="false" [expandable]="false" [expanded]="false">
  <app-timeline-card [currentPeriod]="currentMatchingPeriod"></app-timeline-card>
</app-timeline-item>

<app-timeline-item
  *ngFor="let compactTimelineEntry of compactTimelineEntrys; let i = index"
  [title]="getTimelineTitle(compactTimelineEntry)"
  [icon]="getTimelineIcon(compactTimelineEntry)"
  [level]="getTimelineLevel(compactTimelineEntry)"
  [inverted]="isTimelineInverted(compactTimelineEntry)"
  [expandable]="isExpandable(compactTimelineEntry)"
  [deeplink]="isDeeplink(compactTimelineEntry)"
  [expanded]="expandedStates[i]"
  (expandedChange)="onExpandedChange($event, i)"
>
  <app-timeline-card [compactTimeline]="compactTimelineEntry" [expanded]="expandedStates[i]"></app-timeline-card>
</app-timeline-item>

<app-timeline-item *ngIf="nextMatchingPeriod" [title]="'Matching period ended.'" [icon]="'check'" [level]="'end'" [inverted]="false" [expandable]="false" [expanded]="false">
  <app-timeline-card [nextPeriod]="nextMatchingPeriod"></app-timeline-card>
</app-timeline-item>
